<template lang="html">
  <div class="file-uploader">

    <div class="files">
      <div v-for="(file, file_i) in value" :key="file.id" class="file-box">
        <span v-if="params && params.type === file.attachment_type && params.request_mode == 'true' " >
          <img v-if="file.is_image" :src="$url(file.thumb.md)"/>
          <div v-else class="mt-3 is-file">
            <b>File:</b>
          </div>
          <div class="filename">
            {{ file.orig_name }}
          </div>
          <b-icon v-if="!disabled" icon="trash" class="btn-del text-danger" @click="value.splice(file_i, 1)"/>
          <a :href="$url(file.original)" target="_blank" class="btn-download">
            <b-icon icon="download" class="download-icon"/>
          </a>
        </span>

        <span v-else-if="params.request_mode == 'false' ">
          <img v-if="file.is_image" :src="$url(file.thumb.md)"/>
          <div v-else class="mt-3 is-file">
            <b>File:</b>
          </div>
          <div class="filename">
            {{ file.orig_name }}
          </div>
          <b-icon v-if="!disabled" icon="trash" class="btn-del text-danger" @click="value.splice(file_i, 1)"/>
          <a :href="$url(file.original)" target="_blank" class="btn-download">
            <b-icon icon="download" class="download-icon"/>
          </a>
        </span>

        <!-- {{(file)}} -->
      </div>
      <div class="file-box" v-if="!disabled">
        <b-button variant="outline-primary" @click="$pickFile(upload, null, accept)" size="md" :disabled="!!file_up">
          <template v-if="!file_up">
            <b-icon icon="upload"/>
            <br>
            Seleziona
          </template>
          <template v-else>
            <b-icon icon="upload"/>
            <br>
            Caricamento...
          </template>
        </b-button>
      </div>
      <div v-else-if="!value.length">
        Nessun file
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: ['value', 'accept', 'disabled', 'params'],
  data() {
    return {
      file_up: null,
    }
  },
  created() {
    if (!this.value) {
      this.$emit('input', [])
    }
  },

  methods: {
    upload(f) {
      this.file_up = f
      let data = new FormData()
      data.append('file', f)
      data.append('type', (this.params) ? this.params.type : null)
      this.$http.post('upload', data).then(res => {
        this.value.push(res.data)
      }).finally(() => {
        this.file_up = null
      })
    },
  },
}
</script>

<style lang="scss">
.file-uploader {
  .files {
    .file-box {
      position: relative;
      text-align: center;
      vertical-align: top;
      padding: .2rem;
      max-width: 11rem;
      width: 13%;
      display: inline-block;

      .filename {
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
        white-space: nowrap;
        padding: .2rem;
        font-size: .8rem;
        opacity: .7;
      }

      img {
        width: 100%;
        box-shadow: 0 0 3px rgba(0, 0, 0, .2);
        border-radius: .3rem;
      }

      .btn {
        // margin: .5rem 0;
      }

      .btn-del {
        position: absolute;
        top: 5px;
        right: 5px;
        font-size: 1.5rem;
        padding: .25rem;
        cursor: pointer;
        background: #fff;
        box-shadow: 0 0 3px rgba(0, 0, 0, .3);
        border-radius: 100px;
        transition: .2s;
        // opacity: .5;
        &:hover {
          opacity: 1;
          background: var(--danger);
          color: #fff !important;
        }
      }

      .btn-download {
        position: absolute;
        top: 5px;
        right: 35px;

        .download-icon {
          font-size: 1.5rem;
          padding: .25rem;
          cursor: pointer;
          background: #fff;
          box-shadow: 0 0 3px rgba(0, 0, 0, .3);
          border-radius: 100px;
          transition: .2s;
          // opacity: .5;
          &:hover {
            opacity: 1;
            background: var(--primary);
            color: #fff !important;
          }

        }
      }
    }
  }
}
</style>
<style media="screen">
.is-file {
  min-height: 50px;
}

.btn-download {
  /* border:1px solid black; */
}
</style>
